import ButtonContainer from "compid/shared/containers/ButtonContainer";
import PageLayoutContainer from "compid/shared/containers/PageLayoutContainer";
import CenterColumnContainer from "compid/shared/containers/PageLayoutContainer/containers/CenterColumnContainer";
import PageView from "compid/shared/containers/PageViewContainer";
import UIButton from "compid/ui/UIButton";
import UITextInput from "compid/ui/UITextInput";

import { BCMSDefaultModel, BCMSRecord, ModalOpen, useWorkflowStep } from "@bcm-dev/bcms-vite";
import InfoAlertNotificationView from "compid/shared/views/Notifications/InfoNotificationView/components/InfoAlertNotificationView";
import { getDefaultBiller, getWorkflowSteps } from "compid/workflows/AddBiller";
import { AddBiller, Bill, Biller } from "model";

import "./styles.css";

export default function AddManageBillerPage(props) {
  // Initalize the workflowStep
  const workflowStep = useWorkflowStep(getDefaultBiller, getWorkflowSteps);
  // Initalize classes with the globalController
  BCMSRecord.globalControllerFor([ Biller, AddBiller, Bill ], workflowStep.globalController);

  const biller = workflowStep.read("biller");
  const bill = workflowStep.read("bill");

  const name = biller.name ? biller.name.toUpperCase() : "";

  const onChange = prop => value => workflowStep.update(["biller", prop], value);
  const submit = evt => {
    // Set defaults
    const defaultAddBiller = BCMSDefaultModel.addBiller();

    const number = biller.number.length > 0 ? `*${ biller.number }` : defaultAddBiller.number;
    const nickname = biller.nickname.length > 0 ? biller.nickname : defaultAddBiller.nickname;
    const zip = biller.zip.length > 0 ? biller.zip : defaultAddBiller.zip;

    workflowStep.update(["biller", "number"], number);
    workflowStep.update(["biller", "nickname"], nickname);
    workflowStep.update(["biller", "zip"], zip);

    const billID = Bill.nextID();
    const billerID = Biller.nextID();

    // If the biller has no id set (meaning the page was routed directly to)
    // Set the biller to the first one in the array
    if(biller.id === undefined) {
      workflowStep.update(["biller"], AddBiller.initAll()[0]);
    }

    // Update the global model
    BCMSRecord.batch([
      Biller.create({ ...biller.record, "billerID" : billerID }),
      AddBiller.delete(biller.id),
      Bill.create({ ...bill.record, "billBillerID" : billerID, "billID" : billID })
    ], workflowStep.globalController);

    // Route to the makeAPayment workflow
    workflowStep.navigate(`/makeAPayment/${ billID }`, { state: { "addedBiller" : biller.record } });
  };

  // "Leave" button is clicked in the "Are you sure you want to leave?" modal.
  const onLeave = () => workflowStep.navigate("/payBills");

  return (
    <PageView className="add-biller-page">
      <p className="page-sub-header semi-bold-text">ADD { name }</p>

      <PageLayoutContainer>
        <CenterColumnContainer>
          <InfoAlertNotificationView 
            className="verify-biller-info-notification"
            text="Please verify the biller information and account number with the biller statement to avoid any payment delays." />

          <div className="form-group flex-container flex-vertical">
            <UITextInput placeHolder="Account number" value={ biller.number } onChange={ onChange("number") } dataPoint="Add_Manage_Biller_Number" ></UITextInput>
            <UITextInput placeHolder="Confirm account number" dataPoint="Add_Manage_Biller_Confirm_Number"></UITextInput>
            <UITextInput placeHolder="Nickname (optional)" value={ biller.nickname } onChange={ onChange("nickname") } dataPoint="Add_Manage_Biller_Nickname"></UITextInput>
            <div className="flex-container flex-horizontal">
              <UITextInput placeHolder="ZIP code (5-digit)" value={ biller.zip } onChange={ onChange("zip") } dataPoint="Add_Manage_Biller_Zip" />
              <UITextInput placeHolder="+ZIP 4 (optional)" />
            </div>

            <ButtonContainer className="form-button-container">
              <UIButton className="secondary-button">
                <ModalOpen id="WantToLeaveModal" data={ {onLeave: onLeave} }>Cancel</ModalOpen>
              </UIButton>
              <UIButton className="primary-button" onClick={ submit } dataPoint="Add_Manage_Biller_Add">Add</UIButton>
            </ButtonContainer>
          </div>
        </CenterColumnContainer>
      </PageLayoutContainer>
    </PageView>
  )
}
